import { Box, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import MiniDrawer from "../core/app/AppDrawer";
import MainSwitch from "../core/main/routing/MainSwitch";


const AppMain = () => {

    let [loginPage, setLoginPage] = useState<boolean>(false);

    useEffect(() => {

        if (window.location.href.includes("login") && !loginPage)
            setLoginPage(true);
        else if (!window.location.href.includes("login") && loginPage)
            setLoginPage(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.location.href])

    return <Grid container item xs={12}>
        <MiniDrawer />
        <Box sx={{ marginTop: "80px", marginLeft: "80px", width: "100%" }} >
            <MainSwitch />
        </Box>
    </Grid>
}

export default AppMain